import { ReactComponent as CloseIcon } from '@paradigm/icons/src/mailru/actions/close.svg';
import theme from '@paradigm/tokens/cloud';
import { ReactComponent as DiskoIcon } from 'img/icons/disko.svg';
import { ReactComponent as VkMusicIcon } from 'img/icons/vk_music.svg';
import React from 'react';
import { IFeatureData } from 'reactApp/constants/products/features';
import { openDisko } from 'reactApp/constants/products/features.constants';

const baseQuotaFeatures: IFeatureData[] = [
    {
        text: 'Без рекламы в Почте и Облаке',
        textJsx: (
            <>
                <a
                    target="_blank"
                    href="https://cloud.mail.ru/promo/quota?utm_source=subscriptions&utm_medium=organic&utm_campaign=single_quota"
                    rel="noreferrer"
                >
                    Без рекламы
                </a>
                {'\u00A0'}в Почте и Облаке
            </>
        ),
        key: 'ad',
    },
    {
        text: 'Загрузка файлов до\u00A0100\u00A0ГБ в Облако',
        key: 'upload',
    },
    {
        text: 'Отправка файлов до\u00A0100\u00A0ГБ в письмах',
        key: 'sending',
    },
    {
        text: 'Автоудаление папок',
        key: 'autodelete',
    },
    {
        text: 'Приоритетная поддержка',
        key: 'support',
    },
];
const baseQuotaProFeatures: IFeatureData[] = [
    {
        text: 'Лицензия Диск-О: на год в подарок',
        key: 'disko',
        icon: <DiskoIcon width={16} height={16} />,
        onClick: openDisko,
        delimiters: true,
    },
    {
        text: 'VK Музыка бесплатно на 3\u00A0месяца',
        key: 'combo',
        icon: <VkMusicIcon width={16} height={16} viewBox="0 0 18 18" />,
        delimiters: true,
    },
];

const baseQuotaProFeatures_6m = [
    {
        ...baseQuotaProFeatures[0],
        text: 'Лицензия ДискО: на 6\u00A0месяцев в подарок',
    },
    {
        ...baseQuotaProFeatures[1],
        text: 'VK Музыка бесплатно на 1\u00A0месяц',
    },
];

const baseQuotaCompact: IFeatureData[] = [
    {
        text: 'Без рекламы в Почте и Облаке',
        key: 'ad',
    },
    {
        text: 'Загрузка файлов до\u00A0100\u00A0ГБ',
        key: 'upload',
    },
    {
        text: 'Приоритетная поддержка',
        key: 'support',
    },
    {
        text: 'И другие возможности',
        textJsx: (
            <>
                И другие{'\u00A0'}
                <a href="#benefits">возможности</a>
            </>
        ),
        key: 'benefits',
    },
];

const baseFreeQuotaCompact: IFeatureData[] = [
    {
        text: 'Реклама в Почте и Облаке',
        key: 'ad',
        icon: <CloseIcon fill={theme.colorIconSecondary.normal} />,
    },
    {
        text: 'Нет загрузки больших файлов',
        key: 'upload',
        icon: <CloseIcon fill={theme.colorIconSecondary.normal} />,
    },
    {
        text: 'Нет приоритетной поддержки',
        key: 'support',
        icon: <CloseIcon fill={theme.colorIconSecondary.normal} />,
    },
    {
        text: 'Нет дополнительных возможностей',
        textJsx: (
            <>
                Нет{'\u00A0'}дополнительных
                <br />
                <a href="#benefits">возможностей</a>
            </>
        ),
        key: 'benefits',
        icon: <CloseIcon fill={theme.colorIconSecondary.normal} />,
    },
];

export const quotaFeatures: Record<string, IFeatureData[]> = {
    quotaTariffsLanding: baseQuotaFeatures,
    freeQuotaCompact: baseFreeQuotaCompact,
    quotaRegular: baseQuotaFeatures,
    quotaCompact: baseQuotaCompact,
    quotaProfessional: [...baseQuotaFeatures, ...baseQuotaProFeatures],
    quotaProfessional_6m: [...baseQuotaFeatures, ...baseQuotaProFeatures_6m],
};
